import { mapState } from 'vuex';

//- 會員基本資料彈窗
import ProfileInfoModalComponent from '@/components/ProfileInfoModal/ProfileInfoModal.vue';
//- 每一個格子
import ServiceGridComponent from '@/components/ServiceGrid/ServiceGrid.vue';
//- 引入 Google Tag Manager 網站追蹤
import trackService from "@/helpers/trackService";

export default {
  name: 'HomeIndex',
  components: {
    //- 會員基本資料
    ProfileInfoModalComponent,
    //- 首頁每一個格子
    ServiceGridComponent,
  },
  data(){
    return {
      //- 是否顯示會員基本資料
      isProfileInfoModalShow: false,
      //- 目前點擊的項目
      nowClickIndex: null,
      nowClickTarget: null,
    }
  },
  mounted(){
    let vm = this;
    vm.$store.dispatch('index/index').then(()=>{
      vm.$Swal.close();
      vm.$store.dispatch('index/getLastestImportantMessage').then((res) => {
        if (res && res.data.data.content) {
          vm.$Swal.fire({
            title: res.data.data.content,
            icon: 'info',
            customClass: {
              title: 'word-break-break-work d-block',
            }
          })
        }
      })
    });
  },
  methods:{
    //- 下方功能點擊後要做的事情
    clickHandler: function(list, index, targetRefName) {
      const vm = this;
      const targetId = list.h5_click_id;

      // GTM 追蹤代碼
      trackService.h5UserClickTrack({ line_uuid: vm.$line_uuid, h5btnID: targetId });

      //- 判斷點選哪一個 component
      if(targetRefName === 'IndexServiceGridComponent') {
        //- 如果點第二次
        if(vm.nowClickIndex == index){
          vm.setClickImg(null, null);
        } else {
          //- 更換點擊的按鈕圖片
          vm.setClickImg(index, targetRefName);
        }
        return;
      } else {
        //- 更換點擊的按鈕圖片
        vm.setCollapseClickImg(index, targetRefName);
        return;
      }
    },
    //- 更換點擊後按鈕圖片
    setClickImg: function(index, targetRefName) {
      let vm = this;
      //- 先更改下拉視窗底部的 nowClickCollapseTarget 為 null, 下拉視窗按鈕才會因為判斷式為 false 而取消樣式
      vm.nowClickCollapseTarget = null
      vm.nowClickIndex = index;
      vm.nowClickTarget = `${targetRefName}_${index}`;
    },
    //- 更換點擊後的 Collapse 的按鈕圖片
    setCollapseClickImg: function(index, targetRefName) {
      let vm = this;
      vm.nowClickCollapseTarget = `${targetRefName}_${index}`;
    },
    //- 點擊 ServiceGrid Component 後
    clickServiceGridHandler: function(info) {
      let vm = this;
      let nowSelectItemKey = vm.indexPageData ? vm.indexPageData.service_pages[info.nowIndex] : null;

      //- 會員基本資料
      if(nowSelectItemKey.option === 'feature' &&  nowSelectItemKey.feature === 'member') {
        vm.$store.dispatch('index/getMemberProfile').then(()=>{
          vm.isProfileInfoModalShow = true;
        })
      }
      //- 重要訊息
      if(nowSelectItemKey.option === 'feature' &&  nowSelectItemKey.feature === 'important_message') {
        vm.$router.push({ name: 'important_message' });
      }
      //- 禮物兌換
      if(nowSelectItemKey.option === 'feature' &&  nowSelectItemKey.feature === 'gift') {
        vm.$router.push({ name: 'gift_manager' });
      }
      //- 銷售懶人包
      if(nowSelectItemKey.option === 'feature' &&  nowSelectItemKey.feature === 'sales') {
        vm.$router.push({ name: 'sale_product' });
      }
      //- 退休試算
      if(nowSelectItemKey.option === 'feature' &&  nowSelectItemKey.feature === 'retirement') {
        //- 導至 URL
        window.location = `${process.env.VUE_APP_RETIREMENT_URL}`;
      }
      //- 其他URL
      if(nowSelectItemKey.option === 'url') {
        //- 導至 URL
        let reg = /\?/;
        window.location = reg.test(nowSelectItemKey.url) ? `${nowSelectItemKey.url}&lineId=${vm.userInfo.userId}` : `${nowSelectItemKey.url}?lineId=${vm.userInfo.userId}`;
      }
    },
    //- 關閉彈窗
    closeHandler: function () {
      let vm = this;
      //- 已經關閉就返回
      if(vm.isProfileInfoModalShow === false) return;
      vm.$store.commit('index/resetMemberProfile');
      vm.nowClickTarget = null
      vm.isProfileInfoModalShow = false;
    },
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,                    //- Line 名稱, 大頭貼, 狀態, Uuid ...等等
      indexPageData: state => state.index.indexPageData,    //- 使用者 會員屬性 累積點數 首頁資料 ...等等
      memberProfile: state => state.index.memberProfile     //- 會員基本資料
    }),
  }
}
